import React, { Component } from 'react';
import { AppContext } from '../context/AppContext';
import { viewMe } from '../services/meService';
import { Link } from 'react-router-dom';
import { getDashboardBoxes } from '../services/dashboardService';

class HomePage extends Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      errorMessage: '',
    };
  }

  componentDidMount() {
    const { dispatch } = this.context;

    viewMe()
      .then((data) => {
        if (data.ok) {
          dispatch({
            type: 'SET_ME',
            payload: {
              owner: data.owner,
              businesses: data.businesses,
            },
          });
        }

        this.setState({
          loading: false,
        });
      })
      .catch((error) => {
        this.setState({
          loading: false,
          errorMessage: error.message || 'שגיאה בטעינת נתוני המשתמש',
        });
      });
  }

  render() {
    const { state } = this.context;
    const { loading, errorMessage } = this.state;
    let dashboardItems = getDashboardBoxes();


    const blockedPhones = [
  '+972510009876',
  '+972502110420',
];
    if (!state.owner || !blockedPhones.includes(state.owner.phone_number)) {
      dashboardItems = dashboardItems.filter((item) => item.key !== 'test_chat');
    }

    if (loading) {
      return (
        <div className="page-shell">
          <div className="simple-page-card">טוען נתונים...</div>
        </div>
      );
    }

    return (
      <div className="page-shell">
        <div className="home-top-card">
          <div className="home-title-area">
            <h1>דף הבית</h1>
            <p>שלום {state.owner ? state.owner.name : ''}</p>
          </div>

          {errorMessage && (
            <div className="message-box error-box">{errorMessage}</div>
          )}
        </div>

        <div className="dashboard-grid">
          {dashboardItems.map((item) => (
            <Link to={item.path} className="dashboard-box" key={item.key}>
              <div className="dashboard-icon">{item.icon}</div>
              <div className="dashboard-text">{item.title}</div>
            </Link>
          ))}
        </div>
      </div>
    );
  }
}

export default HomePage;